<script>
    import {onMount,onDestroy} from 'svelte'
    import StationInfo from '../components/StationInfo.svelte'
    import List from '../components/List.svelte'    
    import {locale, language ,getStationStatus} from '../../languages'
    import {getCurrentLocation, getResource } from '../../service'

    let loading = true
    let params = null
    let items = []
    let meta = { skip:0,limit:30}
    
    
    onMount(()=>{        
        let location = getCurrentLocation();
        location.subscribe( p=>{
            p.then(location => {
               
                getResource("nearme", location)
                .subscribe( p => {
                    p.then(data => {                        
                        items = data
                        
                    })
                    
                })
          
            })
            .catch(err => {
                console.log(err)
            })
        })
    })

    
</script>
<div class="h-full w-full overflow-hidden ">
    <List {items} let:item={item} >        
        <div slot="header" class="w-full p-4 sticky top-0 bg-white">
            <h1 class="w-full text-center shadow-md"> {$language.label_total_results} : { meta.total  || 0}</h1>
        </div>
        <StationInfo station={item} />   
    </List>
</div>
<style>
</style>
